import {
  BROADCAST_DISMISS_ATTENDEE,
  BROADCAST_CLEAR_DISMISSED_ATTENDEE
} from 'actions/Types';

export default (state = [], action) => {
  if (action.type === BROADCAST_DISMISS_ATTENDEE) {
    return state.concat([action.payload]);
  }

  if (action.type === BROADCAST_CLEAR_DISMISSED_ATTENDEE) {
    return state.filter(attendeeId => attendeeId !== action.payload);
  }

  return state;
};
